import React from "react";
import {ApiUtility} from '../common/ApiUtility';
import {EmailUtility} from '../common/EmailUtility';
import {useModelFormEngine} from "../common/hooks/useModelFormEngine";
import {LeaveWithoutSavingWarningUtility} from "../common/LeaveWithoutSavingWarningUtility";
import {MessageDisplayerUtility} from "../common/MessageDisplayerUtility";
import {OverlayLoadingIndicator} from "../common/OverlayLoadingIndicator";
import {ConditionalRenderer} from "../common/ConditionalRenderer";
import {PillButton} from "../common/PillButton";

export let ForgotPasswordPage = function () {
    const formEngine = useModelFormEngine(
        {
            loading: false,
            complete: false,
            email: '',
            label: 'Request Password Reset'
        },
        undefined,
        undefined,
        validateForm,
        undefined,
        save
    );

    function validateForm(handleValidationResult: Function) {
        return new Promise(function (resolve, reject) {
            let validationErrors = [];
            let invalidFields = [];

            Promise.resolve({})
                .then(function () {
                    if (formEngine.dataStore.data().email) {
                        if (!EmailUtility.isValid(formEngine.dataStore.data().email)) {
                            validationErrors.push('Please enter a valid email address.');
                            invalidFields.push('email');
                        }
                    } else {
                        validationErrors.push('Please enter an email address.');
                        invalidFields.push('email');
                    }

                    return handleValidationResult(validationErrors, invalidFields, resolve);
                });
        });
    }

    function save(formModelData: object, disableNavigationBlocker: Function) {
        formEngine.dataStore.updateAndRender({loading: true})
        ApiUtility.sendPasswordResetEmail(formModelData)
            .then(() => {
                disableNavigationBlocker();
                LeaveWithoutSavingWarningUtility.disableLeaveWithoutSavingWarnings();
                formEngine.dataStore.updateAndRender({
                    loading: false,
                    complete: true
                })
            })
            .catch((err: object) => {
                formEngine.dataStore.updateAndRender({loading: false})
                console.log("Error requesting password reset: ", err);
                MessageDisplayerUtility.error('Error requesting password reset.');
            });
    }

    function handleTextFieldChange(fieldName: string, event: React.ChangeEvent<HTMLInputElement>) {
        formEngine.dataStore.updateAndRender({[fieldName]: event.target.value});
    }

    return (
        <div className="pre-login-page">
            <ConditionalRenderer
                if={formEngine.dataStore.data().loading}
                renderer={() => <OverlayLoadingIndicator/>}
            />
            <div className="pre-login-page-content">
                <div className="pre-login-page-header">
                    <img
                        src="/static/images/berger-logo-full-light-gray.svg"
                        className="pre-login-page-logo"
                    />
                </div>
                {(() => {
                    if (!formEngine.dataStore.data().complete) {
                        return (
                            <form
                                className="common-form pre-login-form"
                                onSubmit={
                                    (event: React.SyntheticEvent) => {
                                        if (event) {
                                            event.preventDefault();
                                        }
                                        formEngine.onClickSave()
                                    }
                                }
                            >
                                <div className="common-form-body">
                                    <div className="pre-login-page-label">
                                        {formEngine.dataStore.data().label}
                                    </div>
                                    <div className="pre-login-page-sub-label">
                                        Please enter the email address for your user account.
                                    </div>

                                    <div className="common-form-body-row">
                                        <div className="common-form-field pre-login-field">
                                            <div className="common-form-field-input-container">
                                                <input
                                                    className="common-form-input"
                                                    type="text"
                                                    placeholder="Account Email Address"
                                                    onChange={(event) => handleTextFieldChange("email", event)}
                                                    value={formEngine.dataStore.data().email}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <button className="enter-submit-support-button"></button>
                                    <PillButton
                                        buttonClasses="solid-green-button"
                                        onClick={formEngine.onClickSave}
                                        buttonText={formEngine.dataStore.data().label}
                                    />
                                </div>
                            </form>
                        )
                    } else {
                        return (
                            <div className="pre-login-form">
                                <div className="pre-login-page-label">
                                    Password reset request sent.
                                </div>
                                <div className="pre-login-page-sub-label">
                                    If the email address you entered is associated to a user account, you'll
                                    receive an email at that address that contains instructions for how to
                                    reset your password.
                                </div>
                                <PillButton
                                    buttonClasses="solid-green-button"
                                    onClick={() => {
                                        window.location.replace('/login');
                                    }}
                                    buttonText="OK"
                                />
                            </div>
                        )
                    }
                })()}
                <div className="pre-login-page-footer">
                    <div className="pre-login-page-footer-label">
                        <div className="pre-login-page-footer-label-line"/>
                        <div className="pre-login-page-footer-label-text">
                            Truck Dispatch
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
